module.exports = __webpack_public_path__ + "img/icon_map_13_on_110.b868c763.png";